import { forwardRef, type ButtonHTMLAttributes } from "react";
import { cn } from "../lib/utils";
import { TONE_BG } from "../lib/tones";
import type { PopTone } from "../types";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & { tone?: PopTone; size?: "sm" | "md" | "lg" | "xl" };

const SIZES = {
  sm: "px-3 py-2 text-sm rounded-xl",
  md: "px-5 py-3 text-base rounded-2xl",
  lg: "px-6 py-4 text-lg sm:text-xl rounded-2xl",
  xl: "px-8 py-5 text-2xl sm:text-3xl rounded-[22px]",
};

export const PopButton = forwardRef<HTMLButtonElement, Props>(({ tone = "orange", size = "md", className, children, ...rest }, ref) => (
  <button
    ref={ref}
    className={cn(
      "btn-pop font-comic uppercase tracking-wide inline-flex items-center justify-center gap-2 select-none focus:outline-none focus-visible:ring-4 focus-visible:ring-ink focus-visible:ring-offset-2",
      TONE_BG[tone],
      SIZES[size],
      className,
    )}
    {...rest}
  >
    {children}
  </button>
));
PopButton.displayName = "PopButton";
